/*
 * BAA (Business Associate Agreement) service — frontend.
 *
 * Compat SDK only, region-pinned (mirrors services/voxpontBeta.js). Backed by
 * the callables in functions/src/baa.
 */
import firebaseApp from "services/firebase";
import { FUNCTIONS_REGION } from "shared/services";

function baaCallable(name) {
  return firebaseApp.functions(FUNCTIONS_REGION).httpsCallable(name);
}

/**
 * Submit a public institutional BAA request (no auth required).
 *
 * @param {{
 *   firstName: string,
 *   lastName: string,
 *   title: string,
 *   email: string,
 *   institutionName: string,
 *   institutionType: string,
 *   notes?: string,
 * }} payload
 * The request is always created. `mode` reflects how it's being fulfilled:
 *  - "manual": the owner is emailed to prepare and send the BAA by hand
 *    (`signingUrl` null, `signingInitiated` false).
 *  - "auto": a DocuSign envelope is opened for in-browser signing; `signingUrl`
 *    is the embedded-signing URL to redirect to. `signingInitiated` is false
 *    (and `signingUrl` null) only when signing couldn't be started.
 *
 * @returns {Promise<{ success: boolean, requestId: string, mode: ("manual"|"auto"), signingInitiated: boolean, signingUrl: (string|null) }>}
 */
export async function submitBAARequest(payload) {
  const fn = baaCallable("submitBAARequest");
  const result = await fn(payload);
  return result.data;
}
